var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticClass: "panel-group", attrs: { gutter: 40 } },
        [
          _c(
            "el-col",
            { staticClass: "card-panel-col", attrs: { xs: 12, sm: 12, md: 6 } },
            [
              _vm.loaded
                ? _c(
                    "div",
                    [
                      _c("pie", {
                        attrs: { "chart-data": _vm.thisM, title: "本月銷售" },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          ),
          _c(
            "el-col",
            { staticClass: "card-panel-col", attrs: { xs: 12, sm: 12, md: 6 } },
            [
              _vm.loaded
                ? _c(
                    "div",
                    [
                      _c("pie", {
                        attrs: { "chart-data": _vm.lastM, title: "上月銷售" },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }